export default __webpack_public_path__ + "static/media/Bild2.8211b6cb.png";